// src/components/ProductManagement/AttributeInput.jsx
import React from "react";

const AttributeInput = ({
  attribute,
  data,
  isCustom = false,
  canToggleFeatured = true,
  onChange,
  onDelete,
}) => {
  // data: برای سیستم: { value, is_featured }
  // برای سفارشی: { title, value, unit, is_featured }
  const MAX_FEATURED=4;
  const { value = "", is_featured = false, title = "", unit = "" } = data || {};

  // تغییر مقدار اصلی
  const handleValueChange = (newVal) => {
    onChange({
      ...data,
      value: newVal,
    });
  };

  // تغییر عنوان (فقط برای سفارشی)
  const handleTitleChange = (newTitle) => {
    onChange({
      ...data,
      title: newTitle,
    });
  };

  // تغییر واحد (برای سفارشی، و اگر بخوای برای سیستم هم قابل استفاده است)
  const handleUnitChange = (newUnit) => {
    onChange({
      ...data,
      unit: newUnit,
    });
  };

  // تغییر شاخص بودن
  const handleFeaturedToggle = () => {
    if (!is_featured && !canToggleFeatured) return;
    onChange({
      ...data,
      is_featured: !is_featured,
    });
  };

  // -----------------------------
  // رندر ورودی بر اساس type
  // -----------------------------
  const renderInputField = () => {
    const type = attribute?.type || "text";

    switch (type) {
      case "select":
        return (
          <select
            value={value}
            onChange={(e) => handleValueChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
          >
            <option value="">انتخاب کنید</option>
            {attribute.predefined_values?.map((opt) => (
              <option key={opt.id} value={opt.value}>
                {opt.value}
              </option>
            ))}
          </select>
        );

      case "number":
        return (
          <input
            type="number"
            value={value}
            onChange={(e) => handleValueChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
          />
        );

      case "color":
        return (
          <input
            type="color"
            value={value || "#000000"}
            onChange={(e) => handleValueChange(e.target.value)}
            className="w-12 h-10 p-1 border border-gray-300 rounded-md"
          />
        );

      // ... بقیه caseها

      default:
        return (
          <input
            type="text"
            value={value}
            onChange={(e) => handleValueChange(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md"
          />
        );
    }
  };

  return (
    <div className="w-full">
      {/* ساختار جدید با Grid */}
      <div className="grid grid-cols-12 gap-3 items-center">

        {/* ستون ۱: لیبل */}
        <div className="col-span-3">
          {isCustom ? (
            <input
              type="text"
              placeholder="عنوان مشخصه"
              value={title}
              onChange={(e) => handleTitleChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
            />
          ) : (
            <label className="block font-medium text-gray-700 text-sm">
              {attribute?.name}
            </label>
          )}
        </div>

        {/* ستون ۲: فیلد ورودی */}
        <div className="col-span-5">
          {renderInputField()}
        </div>

        {/* ستون ۳: واحد اندازه‌گیری */}
        <div className="col-span-2">
          {isCustom ? (
            <input
              type="text"
              placeholder="واحد"
              value={unit}
              onChange={(e) => handleUnitChange(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
            />
          ) : attribute?.unit ? (
            <span className="text-gray-500 text-sm">{attribute.unit}</span>
          ) : null}
        </div>

        {/* ستون ۴: دکمه حذف و چک‌باکس شاخص */}
        <div className="col-span-2 flex items-center gap-2">
          {/* دکمه حذف برای مشخصه‌های سفارشی */}
          {isCustom && onDelete && (
            <button
              type="button"
              onClick={onDelete}
              className="text-red-500 hover:text-red-700"
              title="حذف مشخصه"
            >
              🗑
            </button>
          )}

          {/* چک‌باکس شاخص */}
          <div className="flex items-center gap-1">
            <input
              type="checkbox"
              checked={!!is_featured}
              disabled={!is_featured && !canToggleFeatured}
              onChange={handleFeaturedToggle}
              className="w-4 h-4 rounded-full"
            />
            <span className="text-xs text-gray-700">شاخص</span>
          </div>
        </div>

      </div>

      {/* پیام خطا برای محدودیت شاخص */}
      {!is_featured && !canToggleFeatured && (
        <div className="mt-2 text-right">
          <span className="text-[11px] text-red-500">
            حداکثر {MAX_FEATURED} مشخصه شاخص مجاز است
          </span>
        </div>
      )}
    </div>
  );
};
export default AttributeInput;